module.exports = __webpack_public_path__ + "img/sms-processing.1bb6dd6f.png";